module.exports = __webpack_public_path__ + "static/media/brios-coconut-b.5940181c.webp";